import React from 'react';
import PropTypes from 'prop-types';
import { List, Popover, Row } from 'antd';
import styles from './styles.less';

function MultiplyItemsColumnRender(props) {
  const { itemList, numberShowedItems = 1, showLeftNumber = true, labelName, alignment = 'center' } = props;
  const itemListLength = itemList.length;
  const leftCount = itemListLength - numberShowedItems;

  return (
    <Row type="flex" justify={alignment} align="middle" className={styles.multiplyWrap}>
      <List
        dataSource={numberShowedItems ?
          itemList.slice(0, numberShowedItems) :
          [`${labelName}${leftCount > 1 ? 's' : ''}:`]
        }
        renderItem={message => (<List.Item>{message}</List.Item>)}
      />
      {itemListLength > numberShowedItems &&
      <Popover
        className={styles.moreInfoList}
        content={
          <List
            dataSource={itemList.slice(numberShowedItems)}
            renderItem={message => (
              <List.Item className={styles.moreInfoItem}>
                {message}
              </List.Item>
            )}
          />
        }
      >
        <span className={styles.moreInfoCount}>
          {numberShowedItems ? '+' : null} {showLeftNumber ? leftCount : null}
        </span>
      </Popover>}
    </Row>
  );
}

MultiplyItemsColumnRender.propTypes = {
  labelName: PropTypes.string,
  alignment: PropTypes.string,
  itemList: PropTypes.arrayOf(PropTypes.string).isRequired,
  numberShowedItems: PropTypes.number,
  showLeftNumber: PropTypes.bool,
};

export default MultiplyItemsColumnRender;



// WEBPACK FOOTER //
// ./src/components/common/Table/MultiplyItemsColumnRender.js